import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const openAuth = (mode) => window.dispatchEvent(new CustomEvent('bwgela-open-auth', { detail: mode }));

// /login and /signup links (used in emails) open the sign-in window on the home page.
export const AuthRedirect = ({ mode }) => {
  useEffect(() => { setTimeout(() => openAuth(mode), 400); }, [mode]);
  return <Navigate to="/" replace />;
};

// Invitation to sign up, shown under course titles to visitors who are not logged in.
export const SignUpPrompt = ({ inline = false }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading || isAuthenticated) return null;
  return (
    <section className={inline ? '' : 'px-4 sm:px-6 pt-10'} data-testid="signup-prompt-section">
      <div className="bg-[#F5F5DC] text-black rounded-xl px-4 py-3 max-w-xl mx-auto text-left flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5" data-testid="signup-prompt">
        <div className="flex-1">
          <p className="text-sm font-medium text-black">Sign up to get the most from our courses</p>
          <p className="text-xs text-black/70 mt-0.5">Monitor your progress, use the course notes and your lesson journal.</p>
          <p className="text-xs text-black/70 mt-0.5">No obligation · No cost · No credit card · No sales</p>
        </div>
        <div className="flex sm:flex-col items-center sm:items-end gap-3 sm:gap-1 shrink-0">
          <button type="button" onClick={() => openAuth('register')} className="px-5 py-1.5 rounded-md bg-black text-[#F5F5DC] text-sm font-medium hover:bg-black/80 transition-colors" data-testid="signup-prompt-btn">
            Sign Up
          </button>
          <button type="button" onClick={() => openAuth('login')} className="text-xs text-black/70 underline hover:no-underline" data-testid="signup-prompt-login">Log in</button>
        </div>
      </div>
    </section>
  );
};
